export function parseErrorList(error: ErrorResponse) {
  let errorList = [];
  if (typeof error === 'string') {
    errorList.push(error);
  }
  if (typeof error === 'object') {
    Object.keys(error).forEach((key) => {
      const value = error[key];
      if (Array.isArray(value)) {
        errorList = errorList.concat(value);
      }
    });
  }
  return errorList;
}

export function parseErrorMessage(error: ErrorResponse) {
  const errorList = parseErrorList(error);
  return errorList.join(' ');
}